import script from "./BaseTemplateReceiptLayers.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTemplateReceiptLayers.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTemplateReceiptLayers.vue?vue&type=style&index=0&id=ded42aee&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded42aee"]])

export default __exports__